import styled from "styled-components";

export const StateContainer = styled.div`
  display: grid;
  place-content: center;
  height: 100%;
`;

export const StateContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const StateHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const StateHeading = styled.h1`
  margin: 0;
  font-size: 32px;
  font-family: "PP Formula";
  font-weight: 300;
  color: #00b5c1;
`;

export const StateHeadingBrand = styled.span`
  font-weight: 800;
  font-family: "PP Formula";
`;

export const StateParagraph = styled.p`
  margin: 0;
  font-size: 20px;
`;

export const StateCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;

export const StateFooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

export const StateButton = styled.button`
  font-family: "PP Formula";
  border-radius: 9999px;
  padding: 8px 16px;
  height: 36px;
  font-size: 13px;
  background-color: #171717;
  color: #fff;
  border: none;
  cursor: pointer;
  width: fit-content;
`;

export const StateLink = styled.span`
  color: rgba(29, 122, 252, 0.7);
  font-size: 14px;
  cursor: pointer;
`;

export const StateContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;
